import * as React from 'react';
import { connect } from 'react-redux';
import {
    fetchSeller,
    editSeller,
    fetchIntegradores,
    fetchFacturaciones
} from '../../actions/sellersActions';
import TiposParaGuardar from './TipoPublicaciones/TiposParaGuardar';

class Publicacion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            checked: 0,
            listaIdTiposPublicaciones: []
        }
    };

    componentDidMount() {
        this.props.fetchFacturaciones();
    }

    onRadioChange = (event) => {
        this.setState({
            checked: event.target.value,
            didEdit: true
        });

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    onSubmitRadio = (e) => {
        e.preventDefault();
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    componentWillReceiveProps = () => {
        if (this.didEdit) {
            this.props.fetchSeller(this.props.id);
            this.setState({ didEdit: false });
        }
    }

    goToSelectTipoPublicaciones = (e) => {
        e.preventDefault();
        this.props.history.push("/Sellers/TiposPublicaciones/Select");
    }


    render() {
        const { isCategory, isAdminMod } = this.props.userType;

        let facturaciones = null;
        if (this.props.facturaciones != undefined) {
            facturaciones = this.props.facturaciones.map((item, i) => {
                return (
                    <option key={i} value={item.codigo}>{item.descripcion}</option>
                )
            })
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                            <label>Tipo de Facturación</label>
                            <select
                                disabled={!isAdminMod}
                                className="form-control"
                                value={this.props.seller.tipoFacturacion.codigo}
                                onChange={this.myChangeHandler}
                                id="inlineFormCustomSelect"
                                name="tipoFacturacion"
                            >
                                {facturaciones}
                            </select>
                        </div>

                        <div className="form-group">
                            <label>URL push ordenes</label>
                            <input
                                type="text"
                                name="urlPushOrdenes"
                                className="form-control"
                                value={this.props.seller.urlPushOrdenes}
                                onChange={this.myChangeHandler}
                                disabled={!isCategory && !isAdminMod}
                            />
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <TiposParaGuardar history={this.props.history} />
                        {(isCategory || isAdminMod) &&
                            <button
                                onClick={this.goToSelectTipoPublicaciones}
                                className="btn btn-sm background-rojo-megatone waves-light m-r-10"
                            >
                                Seleccionar Tipo de Publicación
                            </button>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    seller: JSON.stringify(state.general.generalObject) != "{}"
        ? state.general.generalObject
        : state.sellers.seller
    ,
    facturaciones: state.sellers.facturaciones,
    integradores: state.sellers.integradores,
});

export default connect(mapStateToProps, {
    fetchSeller,
    editSeller,
    fetchIntegradores,
    fetchFacturaciones
})(Publicacion);